var render = function render(){var _vm=this,_c=_vm._self._c;return _c('facial-features-template',{attrs:{"gender":_vm.gender,"eye-color":_vm.eyeColor,"natural-hair-color":_vm.naturalHairColor,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }